// extracted by mini-css-extract-plugin
module.exports = {"release":"TargetDateWithReleaseDate__release--g6NJl"};